import { createAction } from '@reduxjs/toolkit'

import type { RefundLineRequest } from '../api/refundsApi'

/**
 * Команды окна возврата — plain actions (F05): экран → actions → команда →
 * listener → запрос. Ключ идемпотентности создаёт listener ОДИН раз на
 * нажатие. Действующее лицо в команде не передаётся: его знает только токен.
 */
interface Seat {
  resourceId: string
  registerKey: string
  deviceId: number
}

interface RefundRef extends Seat {
  receiptId: string
  refundId: string
  /** Версия возврата, которую видел человек. */
  expectedVersion: number
}

/** «Вернуть»: создать возврат по чеку. `expectedVersion` — версия МОЕЙ сессии за кассой. */
export const refundCreateRequested = createAction<
  Seat & { receiptId: string; lines: readonly RefundLineRequest[]; expectedVersion: number }
>('aqsi/refunds/createRequested')
export const refundPayRequested = createAction<RefundRef>('aqsi/refunds/payRequested')
export const refundFiscalizeRequested = createAction<RefundRef>('aqsi/refunds/fiscalizeRequested')
export const refundCancelRequested = createAction<RefundRef>('aqsi/refunds/cancelRequested')
/** «Проверить статус»: ЧТЕНИЕ кассы, возврата и операции, а не повтор команды. */
export const refundStatusCheckRequested = createAction<Seat & { receiptId: string; operationId: string | null }>(
  'aqsi/refunds/statusCheckRequested',
)
/** «Сверить с кабинетом»: служба только читает операцию кабинета по сохранённому id. */
export const refundReconcileRequested = createAction<
  Seat & { receiptId: string; operationId: string; expectedVersion: number }
>(
  'aqsi/refunds/reconcileRequested',
)
export const refundReloadRequested = createAction<{ resourceId: string; receiptId: string }>(
  'aqsi/refunds/reloadRequested',
)
